export const colors = {
  main: "#8DC63F",
  secondary: "#1B1B1B",
  background: "#FFFFFF",
  darkgray: "#4B465C",
  lightgray: "#6F6B7D",
  gray: "#A8AAAE",
};
